<template>
  <div class="form-wrapper" v-if="!show">
    <gkForm class="form" name="form" ref="form" v-model="formData">
      <gkFormText 
        placeholder="请输入邮箱"
        :color="color" 
        size="normal" 
        field="email" 
        :rule="[{email: '请输入正确的邮箱'}]"
        validity 
        v-model="email"
      >
        <template slot="error" slot-scope="{message}">
          <span class="custom-error">
            <i class="iconfont err-icon">&#xe612;</i>
            {{message}}
          </span>
        </template>
      </gkFormText>
      <transition name="fade">
        <CaptchaInput 
          v-if="showImgCaptch"
          field="code"
          :color="color"
          validity 
          :url="`/public/v1/user/createCaptch?${email}`"
          :rule="[{required: '请输入验证码'}, 'imgCaptcha']"
        >
          <template slot="error" slot-scope="{message}">
            <span class="custom-error">
              <i class="iconfont err-icon">&#xe612;</i>
              {{message}}
            </span>
          </template>
        </CaptchaInput>
      </transition>
    </gkForm> 
    <gkButton useLock :color="color == 'green' ? 'lightGreen' : color" size="height45" @click="onSubscribe">
      <template slot="status" slot-scope="{locked}">
        <div v-if="!locked">
          立即订阅 <i class="iconfont">&#xe62f;</i>
        </div>
        <div v-else>正在发送邮件...</div>
      </template>
    </gkButton>
  </div>
  <div :class="['sended', color]" v-else>
    <p>验证链接已发送至您的邮箱：</p>
    <p>{{email}}</p>
    <a :href="jumpUrl" target="_blank">请点击邮件中的链接完成订阅</a>
  </div>
</template>
<script>
import VueTypes from 'vue-types'
import gkButton from 'gkui/button'
import gkForm from 'gkui/form/Form'
import gkFormText from 'gkui/form/FormText'
import CaptchaInput from '../captcha/CaptchaInput'

import emailUrlMap from '../../utils/emailUrl'

import WeeklyService from '../../service/weekly.service'
export default {
  name: 'component-name',
  components: {
    gkButton,
    gkForm,
    gkFormText,
    CaptchaInput
  },
  props: {
    color: VueTypes.oneOf(['green', 'blue']).def('green')
  },
  data () {
    return {
      show: false,
      formData: {},
      email: '',
      showImgCaptch: false,
      emailUrlMap,
      jumpUrl: ''
    }
  },
  computed: {
  },
  watch: {
    email (newVal) {
      let email = newVal.split('@')
      if (email.length) {
        this.jumpUrl = emailUrlMap[email[1]]
      }
    }
  },
  created () {
  },
  methods: {
    onSubscribe ({clear}) {
      window.ga && window.ga('send', 'event', '每周精要订阅点击数', this.$route.name)
      this.$refs.form.validate().then(form => {
        WeeklyService.subWeek(form.formData).then(res => {
          window.ga && window.ga('send', 'event', '每周精要订阅点击数-发送邮件成功', this.$route.name)
          clear && clear()
          this.show = true
        }).catch(err => {
          clear && clear()
          if (err && err.code) {
            let code = err.code.toString()
            if (code === '-4008' || code === '-4003') {
              this.showImgCaptch = true
              this.$refs.form.invalid('code', err.msg)
              return
            }

            if (code === '-3004' || code === '-3005' || code === '-3006') {
              this.$refs.form.invalid('code', '请刷新验证码')
            }
            this.$refs.form.invalid('email', err.msg)
          }
        })
      }).catch(err => {
        console.log(err)
        clear && clear()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/_common';
  .form-wrapper {
    & .form {
      margin-bottom: 15px;
    }
  }

  .custom-error {
    & .err-icon {
      font-size: 12px;
    }
  }

  [gk-button][gkbtn-color="blue"] {
    background: #5079D2;
    border-color: #5079D2;
  }

  .sended {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100px;
    background: #F0F9F8;
    border: 1px solid $lightGreen; border-radius: 3px;

    & p {
      margin-bottom: 10px;
      @include lineFont(14, 400);
      color: $bodyBlack;
    }

    & a {
      @include lineFont(14, 400);
      color: $lightGreen;
    }

    &.blue {
      background: #fff;
      border-color: #5079D2;

      & a {
        color: #5079D2;
      }
    }
  }
</style>
